<template>
<!-- footer 시작 -->
    <footer id="footer" class="footer" :class="{ hide: isShow }">
      <div class="footer_top">
        <div class="footer_gnb">
          <ul class="gnb">
            <li class="gnb_menu">
              <router-link to="/hospital" class="gnb_link">사업</router-link>
              <div class="sub-nav">
                <ul class="sub-nav_list">
                  <li class="sub-nav_menu">
                    <router-link to="/hospital" class="sub-nav_link"
                      >병원진료</router-link
                    >
                  </li>
                  <li class="sub-nav_menu">
                    <router-link to="/move" class="sub-nav_link"
                      >이동진료</router-link
                    >
                  </li>
                  <li class="sub-nav_menu">
                    <router-link to="/salvation" class="sub-nav_link"
                      >구제사역</router-link
                    >
                  </li>
                  <li class="sub-nav_menu">
                    <router-link to="/edu" class="sub-nav_link"
                      >의료인교육</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="gnb_menu">
              <router-link to="/news" class="gnb_link">활동</router-link>
              <div class="sub-nav">
                <ul class="sub-nav_list">
                  <li class="sub-nav_menu">
                    <router-link to="/news" class="sub-nav_link"
                      >활동게시판</router-link
                    >
                  </li>
                  <li class="sub-nav_menu">
                    <router-link to="/notice" class="sub-nav_link"
                      >공지사항</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="gnb_menu">
                <router-link to="/" class="gnb_link">후원</router-link>
                <div class="sub-nav" @mouseenter="showSubMenu" @mouseleave="hideSubMenu">
                  <ul class="sub-nav_list">
                    <li class="sub-nav_menu">
                      <button class="sub-nav_link" @click="opendonation()" style="background: transparent; border: 0">월드휴먼브리지</button>
                    </li>
                    <li class="sub-nav_menu" @mouseleave="hideMissionFundSubMenu" >
                      <div class="sub-nav_link hover" @mouseenter="showMissionFundSubMenu" style="background: transparent; border: 0">미션 펀드</div>
                      <div v-show="showMissionFund" class="sub-nav_content" style="text-align:left; margin-left:50px">
                        <!-- 미션 펀드에 대한 하위 메뉴 내용 -->
                        <ul>
                          <li>
                            <button class="sub-nav_link" @click="opendonation3()" style="background: transparent; border: 0;margin-top:7px">혈액투석후원</button>
                          </li>
                          <li>
                            <button class="sub-nav_link" @click="opendonation4()" style="background: transparent; border: 0;margin-top:7px">병원신축후원</button>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="sub-nav_menu" @mouseleave="hideReceiptSubMenu">
                      <div class="sub-nav_link hover" @mouseenter="showReceiptSubMenu" style="background: transparent; border: 0">기부영수증</div>
                      <div v-show="showReceipt" class="sub-nav_content" style="text-align:left; margin-left:50px">
                        <!-- 기부영수증에 대한 하위 메뉴 내용 -->
                        <ul>
                          <li>
                            <button class="sub-nav_link" @click="opendonation5()" style="background: transparent; border: 0;margin-top:7px">월드휴먼브리지</button>
                          </li>
                          <li>
                            <button class="sub-nav_link" @click="opendonation6()" style="background: transparent; border: 0;margin-top:7px">미션펀드</button>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            <li class="gnb_menu">
              <router-link to="/greeting" class="gnb_link">아가페</router-link>
              <div class="sub-nav">
                <ul class="sub-nav_list">
                  <li class="sub-nav_menu">
                    <router-link to="/greeting" class="sub-nav_link"
                      >인사말</router-link
                    >
                  </li>
                  <li class="sub-nav_menu">
                    <router-link to="/history" class="sub-nav_link">병원연혁</router-link>
                  </li>
                  <!-- <li class="sub-nav_menu">
                    <router-link to="/doctors" class="sub-nav_link">의료진</router-link>
                  </li> -->
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer_bottom">
        <div class="inner">
          <div class="footer_left">
            <h1 class="levware gray"><router-link to="/" class="levware_link"></router-link></h1>
            <address class="footer_addr">
              <ul class="footer_addr-list">
                <li class="footer_addr-item">
                  <span class="footer_addr-title">후원계좌</span
                  ><a href="#" class="footer_addr-link">
                    IBK 기업은행 341-050240-04-055</a
                  >
                </li>
                <li class="footer_addr-item">
                  <span class="footer_addr-title">전화번호 </span> 1670-7618
                </li>
              </ul>
            </address>
            <p class="footer_copy">
              <i class="footer_copy-icon">개인정보처리방침</i><br />
              <i class="footer_copy-icon">©</i> COPYRIGHT ©AGAPE
              <br class="hide show_480" />ALL RIGHTS RESERVED.
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- footer 끝 -->
</template>

<script>
import '../assets/css/common.css'

export default {
  data() {
    return {
      scrollPosition: 0,
      isShow: false,
    };
  },
  methods: {

  },
};
</script>

<style>
@import '../assets/css/style.css';
</style>
